module.exports = __webpack_public_path__ + "img/blue_jacket_and_white_stripe_tee-400x520.0f5fd862.jpg";